import React, { useEffect } from "react";
import { Table, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCustomerModel } from "../customerModel";
import { ICustomerDetail } from "../customerService";
import { useDictModel } from "../../dict/dictModel";
import moment from 'moment';


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys, disableCustomer
    } = useCustomerModel();
    // const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, []);

    const columns: ColumnsType<ICustomerDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '客户编码',
            width: 180,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'name',
            fixed: "left",
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '贸易国别',
            width: 140,
            dataIndex: 'countryName',
        }, {
            title: '联系人',
            width: 140,
            dataIndex: 'contact',
        }, {
            title: '联系电话',
            width: 140,
            dataIndex: 'phone',
        }, {
            title: '客户负责人',
            width: 140,
            dataIndex: 'staffName',
        }, {
            title: '客户类型',
            width: 160,
            dataIndex: 'categoryName',
        },
        // {
        //     title: '创建人',
        //     width: 160,
        //     dataIndex: 'createUser',
        // },
        {
            title: '创建日期',
            width: 180,
            dataIndex: 'createTime',
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        },
        {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text, record) => (
                <Switch
                    checkedChildren={"开启"}
                    unCheckedChildren={"关闭"}
                    checked={!!record.status}
                    onChange={(checked: boolean, e: MouseEvent) => {
                        e.stopPropagation();
                        disableCustomer(record.code, checked ? 1 : 0)
                    }}
                />
            ),
        }
    ];



    //点击行选高亮
    const onRow = (record: ICustomerDetail) => {
        let findObj = selectedRowKeys.find(item => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.id !== record.id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };

    return (
        <Table
            loading={loading}
            rowKey={record => record.id}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.id);
                            return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.id)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
